export const paginationInitialState = {
  page: 0,
  rowsPerPage: 10,
};

export const paginationReducers = {
  setPageNumber: (state, { payload }) => {
    state.pagination.page = Math.max(0, Number(payload) || 0);
  },
  setRowsPerPage: (state, { payload }) => {
    state.pagination.rowsPerPage = Math.max(1, Number(payload) || 10);
    state.pagination.page = 0;
  },
};
